/* eslint-disable eqeqeq */
import { Component } from 'preact';
import PropTypes from 'prop-types';

import ItemCard from '../ItemCard';
import {
  setPersonalInformations,
  setModelInformations,
  setUsedModelValue,
  setEntryValue,
  setUsedModelInformations,
  setInstallments,
  setFinancingOptions,
  setUsedOnChange,
} from '../../../stores/FinancingSimulator';
import { currencyStringToNumber, removeCurrencyFormat } from '../utils';

export default class FinancingSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      email: '',
      phoning: false,
      mailing: false,
      whatsapping: false,
      model: '',
      versionName: '',
      unit: '',
      modelThumb: '',
      usedOnChange: '',
      usedModelBrand: '',
      usedModelName: '',
      usedModelYear: '',
      usedModelValue: '',
      entryValue: '',
      installments: '',
      installmentValue: '',
      financedValue: '',
      interestRate: '',
      showDetailsOpen: false,
    };

    window.store.FinancingSimulator.watch(setModelInformations, store => {
      this.setState({
        model: store.model,
        versionName: store.versionName,
        unit: store.unit,
        modelThumb: store.modelThumb,
        modelValue: store.modelValue,
      });
    });

    window.store.FinancingSimulator.watch(setUsedOnChange, store => {
      this.setState({
        usedOnChange: store.usedOnChange,
      });
    });

    window.store.FinancingSimulator.watch(setUsedModelValue, store => {
      this.setState({
        usedModelValue: store.usedModelValue,
      });
    });

    window.store.FinancingSimulator.watch(setUsedModelInformations, store => {
      this.setState({
        usedModelBrand: store.usedModelBrand,
        usedModelName: store.usedModelName,
        usedModelYear: store.usedModelYear,
      });
    });

    window.store.FinancingSimulator.watch(setPersonalInformations, store => {
      this.setState({
        username: store.username,
        email: store.email,
        mailing: store.mailing,
        phoning: store.phoning,
        whatsapping: store.whatsapping,
      });
    });

    window.store.FinancingSimulator.watch(setEntryValue, store => {
      this.setState({
        entryValue: store.entryValue,
      });
    });

    window.store.FinancingSimulator.watch(setInstallments, store => {
      this.setState({
        installments: store.installments,
      });
    });

    window.store.FinancingSimulator.watch(setFinancingOptions, store => {
      this.setState({
        installmentValue: store.installmentValue,
        financedValue: store.financedValue,
        interestRate: store.interestRate,
      });
    });

    this.getTotalFinancingValue = this.getTotalFinancingValue.bind(this);
    this.getTotalEntryValue = this.getTotalEntryValue.bind(this);
    this.maskedValue = this.maskedValue.bind(this);
    this.handleShowDetails = this.handleShowDetails.bind(this);
    this.vehicleValueMinusEntry = this.vehicleValueMinusEntry.bind(this);
  }

  handleShowDetails() {
    const { showDetailsOpen } = this.state;

    this.setState({
      showDetailsOpen: !showDetailsOpen,
    });
  }

  getTotalFinancingValue() {
    const { financedValue } = this.state;

    return this.maskedValue(financedValue);
  }

  getTotalEntryValue() {
    const { entryValue, usedModelValue } = this.state;

    let totalEntry = 0;

    if (entryValue)
      totalEntry += parseInt(removeCurrencyFormat(entryValue), 10);

    if (usedModelValue)
      totalEntry += parseInt(removeCurrencyFormat(usedModelValue), 10);

    return this.maskedValue(totalEntry);
  }

  getFormattedInstallmentValue() {
    const { installmentValue } = this.state;
    const formattedInstallmentValue = this.maskedValue(installmentValue);

    return `R$ ${formattedInstallmentValue}`;
  }

  getModelName(modelName, versionName) {
    return `${modelName} ${versionName}`;
  }

  maskedValue(number) {
    if (!number) return '';
    return number.toLocaleString('pt-br', { minimumFractionDigits: 2 });
  }

  formatValue(number) {
    if (!number) return null;

    const convertedNumber = parseFloat(number.replace(/\D/g, ''));

    return this.maskedValue(convertedNumber);
  }

  vehicleValueMinusEntry() {
    const { modelValue } = this.state;
    const totalEntry = this.getTotalEntryValue();

    if (!modelValue || !totalEntry) return '0,00';

    const modelNumberValue = currencyStringToNumber(modelValue);
    const totalEntryNumber = currencyStringToNumber(this.getTotalEntryValue());

    return (modelNumberValue - totalEntryNumber).toLocaleString('pt-br', {
      minimumFractionDigits: 2,
    });
  }

  render() {
    const {
      username,
      email,
      mailing,
      phoning,
      whatsapping,
      entryValue,
      modelValue,
      usedOnChange,
      usedModelBrand,
      usedModelName,
      usedModelYear,
      usedModelValue,
      model,
      versionName,
      modelThumb,
      unit,
      installments,
      installmentValue,
      showDetailsOpen,
      interestRate,
    } = this.state;

    return (
      <div className="financing-summary">
        <h2 className="step__title">Resultado da simulação</h2>

        <div className="financing-summary-options">
          <div className="financing-summary-options__col">
            <h4 className="financing-summary-options__title">
              Valor das parcelas
            </h4>
            <p className="financing-summary-options__value">
              {this.getFormattedInstallmentValue()}
            </p>
          </div>
          <div className="financing-summary-options__col">
            <h4 className="financing-summary-options__title">
              Quantidade de parcelas
            </h4>
            <p className="financing-summary-options__value">{installments}</p>
          </div>
          <div className="financing-summary-options__col">
            <button
              type="button"
              className={`btn financing-summary__show-details ${
                showDetailsOpen && 'financing-summary__show-details--open'
              }`}
              onClick={this.handleShowDetails}
            >
              {showDetailsOpen ? 'Ocultar detalhes' : 'Ver detalhes'}
              <i className="icon icon-chevron-down" />
            </button>
          </div>
        </div>

        <div
          className={`financing-summary-info ${!showDetailsOpen && 'd-none'}`}
        >
          <div className="personal-data">
            <h3 className="financing-summary-info__title">Meus dados</h3>
            <div className="summary__info-item">
              <h4 className="bold-label">Nome: </h4>
              <p className="financing-summary-info__value">{username}</p>
            </div>
            <div className="summary__info-item">
              <h4 className="bold-label">Email: </h4>
              <p className="financing-summary-info__value">{email}</p>
            </div>
            <div className="summary__info-item">
              <h4 className="bold-label">Preferência de contato: </h4>
              <p className="financing-summary-info__value">
                {!!mailing && <span className="contact-option">E-mail</span>}
                {!!phoning && <span className="contact-option"> Telefone</span>}
                {!!whatsapping && (
                  <span className="contact-option"> Whatsapp</span>
                )}
              </p>
            </div>
          </div>
          <div className="new-vehicle-data">
            <div className="data">
              <h3 className="financing-summary-info__title">
                Dados do veículo
              </h3>

              <div className="summary__info-item">
                <h4 className="bold-label">Modelo: </h4>
                <p className="financing-summary-info__value">
                  {this.getModelName(model, versionName)}
                </p>
              </div>

              <div className="summary__info-item">
                <h4 className="bold-label">Valor: </h4>
                <p className="financing-summary-info__value">R$ {modelValue}</p>
              </div>

              {unit && (
                <div className="summary__info-item">
                  <h4 className="bold-label">Unidade: </h4>
                  <p className="financing-summary-info__value">{unit}</p>
                </div>
              )}
            </div>
          </div>
          {usedOnChange === 'sim' && (
            <div className="new-vehicle-data">
              <div className="data">
                <h3 className="financing-summary-info__title">
                  Dados do seminovo
                </h3>

                <div className="summary__info-item">
                  <h4 className="bold-label">Modelo: </h4>
                  <p className="financing-summary-info__value">
                    {usedModelBrand
                      ? `${usedModelBrand} ${usedModelName} - ${usedModelYear}`
                      : 'Nenhum seminovo informado'}
                  </p>
                </div>

                <div className="summary__info-item">
                  <h4 className="bold-label">Valor do seminovo: </h4>
                  <p className="financing-summary-info__value">
                    R$ {this.formatValue(usedModelValue) || '0,00'}
                  </p>
                </div>
              </div>
            </div>
          )}
          <div className="financing-data">
            <div className="data">
              <h3 className="financing-summary-info__title">
                Dados do financiamento
              </h3>
              <div className="summary__info-item">
                <h4 className="bold-label">Valor do veículo: </h4>
                <p className="financing-summary-info__value bold-label">
                  R$ {modelValue}
                </p>
              </div>
              <div className="summary__info-item">
                <h4 className="bold-label">
                  {usedOnChange === 'sim'
                    ? 'Valor da entrada total:'
                    : 'Valor da entrada:'}
                </h4>
                <p className="financing-summary-info__value bold-label">
                  R$ {this.getTotalEntryValue() || '0,00'}
                </p>
              </div>
              {usedOnChange === 'sim' && (
                <div className="summary__info-item summary__info-item--white">
                  <h5 className="simple-label extra-data-label">
                    Valor da entrada:
                  </h5>
                  <p className="financing-summary-info__value">
                    R$ {this.formatValue(entryValue) || '0,00'}
                  </p>
                </div>
              )}
              {usedOnChange === 'sim' && (
                <div className="summary__info-item summary__info-item--white">
                  <h5 className="simple-label extra-data-label">
                    Valor do veículo seminovo:
                  </h5>
                  <p className="financing-summary-info__value">
                    R$ {this.formatValue(usedModelValue) || '0,00'}
                  </p>
                </div>
              )}
              <div className="summary__info-item">
                <h4 className="bold-label">Valor financiado: </h4>
                <p className="financing-summary-info__value bold-label">
                  R$ {this.vehicleValueMinusEntry()}
                </p>
              </div>
              <div className="summary__info-item">
                <h4 className="bold-label">Parcelas: </h4>
                <p className="financing-summary-info__value">
                  {installments}x de R$ {this.maskedValue(installmentValue)}{' '}
                </p>
              </div>
              <div className="summary__info-item">
                <h4 className="bold-label">Soma final das parcelas: </h4>
                <p className="financing-summary-info__value">
                  R$ {this.getTotalFinancingValue()}
                </p>
              </div>
              <div className="summary__info-item">
                <h4 className="bold-label">Taxa de juros: </h4>
                <p className="financing-summary-info__value">
                  {interestRate.toString().replace('.', ',')}%
                </p>
              </div>
            </div>
          </div>
        </div>

        <ItemCard
          modelName={model}
          versionName={versionName}
          unit={unit}
          thumb={modelThumb}
          thumbAlt={model}
          textPrice="Valor do modelo"
          price={modelValue}
        />

        <div className="financing-summary__security-text">
          <div className="financing-summary__security-text__header">
            <div>
              <i className="icon icon-security" />
            </div>
            <span>Fique tranquilo! Essa simulação é sem compromisso.</span>
          </div>

          <span className="financing-summary__security-text__content">
            O processo a seguir trata-se apenas de uma simulação de condições de
            financiamento, sem qualquer caráter vinculativo como oferta ou
            proposta de crédito e é estabelecido com base nas informações
            selecionadas pelo cliente, as quais deverão ser confirmadas caso o
            cliente opte por esta modalidade de pagamento, bem como submetida à
            instituição financeira para validação e análise de crédito.
            <br />
            <br />
            Os valores das tarifas, parcelas e condições de financiamento
            poderão ser alterados com base na análise individual do perfil do
            cliente e, no caso de opção pela contratação do financiamento, o
            cliente será previamente informado sobre o custo efetivo total da
            operação, no qual constará a taxa pactuada, tributos incidentes na
            operação, tarifas, eventuais seguros selecionados e serviços
            eventualmente contratados, além de outras despesas que poderão ser
            cobradas do cliente caso, após a devida análise, seu crédito seja
            aprovado.
            <br />
            <br />
            Ao fornecer seus dados pessoais acima, você autoriza que a{' '}
            {this.props.channel} compartilhe seus dados com a Stellantis
            Financiamentos, para viabilizar o envio de uma proposta de
            financiamento do veículo de seu interesse. Saiba como a Stellantis
            Financiamentos trata seus dados pessoais na Política de Privacidade
            disponível em:{' '}
            <a
              target="_blank"
              href="https://www.stellantisfinanciamentos.com.br/politica-privacidade"
              rel="noreferrer"
            >
              https://www.stellantisfinanciamentos.com.br/politica-privacidade
            </a>
          </span>
        </div>

        <div className="btns-group">
          <button
            type="button"
            className="btn btn-prev btn-prev--outline font-weight-bold"
          >
            Voltar para o simulador
          </button>
          <a
            // eslint-disable-next-line react/prop-types
            href={this.props.linkCtaSummary}
            className="btn button--primary font-weight-bold financing-summary-cta"
          >
            Ir para página inicial
          </a>
        </div>
      </div>
    );
  }
}

FinancingSummary.defaultProps = {
  linkCtaSummary: '',
  channel: '',
};

FinancingSummary.propTypes = {
  linkCtaSummary: PropTypes.string,
  channel: PropTypes.string,
};
